import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getModule } from './gruser';
const GruserModuleLoader = ({ gruser, gruserPage })=>{
    return /*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getModule({
                gruser,
                gruserPage
            })
        ]
    });
};
GruserModuleLoader.displayName = 'GruserModuleLoader';
export default GruserModuleLoader;
